export const HOME_PAGE_ID = 'home';
export const NEW_PAGE_ID = '_new';

export const ORGS_PAGE_ID = 'orgs';
export const ORGS_BASE_URL = `/${ORGS_PAGE_ID}`;
export const ORG_URL = `${ORGS_BASE_URL}/:orgSlug`;

export const PROJECTS_PAGE_ID = 'projects';
export const PROJECTS_BASE_URL = `${ORG_URL}/${PROJECTS_PAGE_ID}`;
export const PROJECT_URL = `${PROJECTS_BASE_URL}/:projectSlug`;

export const CELL_ROUTES_PAGE_ID = 'cellroutes';
export const CELL_METRICS_PAGE_ID = 'cellmetrics';
export const FLOWS_PAGE_ID = 'flows';
export const FLOWS_BASE_URL = `${PROJECT_URL}/${FLOWS_PAGE_ID}`;
